import React from 'react';
import "./HomeComponent.scss";
import homePhoto from "./home_photo.jpg"; // same directory
import CardComponent from '../CardComponent/CardComponent';
import AgendaComponent from '../AgendaComponent/AgendaComponent';
import PhotoComponent from '../PhotoComponent/PhotoComponent';
import SongComponent from '../SongComponent/SongComponent';
import CountDownComponent from '../CountDownComponent/CountDownComponent';
import RsvpSpinComponent from '../RsvpSpinComponent/RsvpSpinComponent';
import RsvpDiceComponent from '../RsvpDiceComponent/RsvpDiceComponent';
import RsvpSlideComponent from '../RsvpSlideComponent/RsvpSlideComponent';

const HomeComponent = () => {
  return (
    <div>
      <h1 className='home-heading'>Vishmi & Sanjana</h1>

      <img
        src={homePhoto}
        alt="Vishmi and Sanjana"
        className="home-photo"
        loading="lazy"
        decoding="async"
      />
      <h2 style={{ fontFamily: "'Great Vibes', cursive", fontWeight: "normal" }}>
        We are glad if you are there!
      </h2>

      {/* Dark variant over a photo background */}
      <section
        style={{
          marginTop: "18px",
          padding: "16px",
          borderRadius: "16px",
          background: "url('./home_photo.jpg') center/cover no-repeat"
        }}
      >
        <CardComponent variant="dark" />
      </section>

      <h2 style={{ fontFamily: "'Great Vibes', cursive", fontWeight: "normal" }}>
        Can't wait to see you, It's only have,
      </h2>

    <CountDownComponent/>

      

      <AgendaComponent />
      <PhotoComponent />
      <SongComponent/>
      <RsvpSlideComponent/>
      <RsvpSpinComponent/>
      <RsvpDiceComponent/>
    </div>
  );
};

export default HomeComponent;
